import script from "./SearchSuggestionResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchSuggestionResult.vue?vue&type=script&setup=true&lang=js"

import "./SearchSuggestionResult.vue?vue&type=style&index=0&id=91de1cec&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91de1cec"]])

export default __exports__